import { ShieldCheck } from 'lucide-react';
import { TwoFactorCard } from '@/app/pages/profile/my-profile-page';

export function PlatformAdminSecurityPage() {
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-bold text-gray-900 dark:text-foreground sm:text-3xl">
          <ShieldCheck className="h-7 w-7" />
          Account Security
        </h1>
        <p className="mt-1 text-gray-600 dark:text-muted-foreground">
          Protect your platform administrator account with two-factor authentication.
        </p>
      </div>

      <div className="max-w-2xl">
        <TwoFactorCard required />
      </div>
    </div>
  );
}
